module.exports = __webpack_public_path__ + "media/home/Press-27259355.png";